module.exports = __webpack_public_path__ + "img/bootstrap-reboot.1b0b13db.svg";